import { render, staticRenderFns } from "./EnvioMensagem.vue?vue&type=template&id=03e53fb1&scoped=true&"
import script from "./EnvioMensagem.vue?vue&type=script&lang=js&"
export * from "./EnvioMensagem.vue?vue&type=script&lang=js&"
import style0 from "./EnvioMensagem.vue?vue&type=style&index=0&id=03e53fb1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e53fb1",
  null
  
)

export default component.exports